<div class="content" [@fadeIn]="state">
  <div class="container" *ngIf="reporting?.IsEnabled == false">
    <div class="row align-items-center mb-5">
      <div class="col">
        <h3 class="mb-0">{{ texts.title | localize }}</h3>
      </div>
    </div>
    <div class="card card-xl">
      <div class="card-body">
        {{ texts.notAvailable | localize }}
      </div>
    </div>

  </div>

  <div class="container" *ngIf="reporting?.IsEnabled != false">
    <div class="row align-items-center mb-5">
      <div class="col">
        <h3 class="mb-0">{{ texts.title | localize }}</h3>
      </div>
      <div class="col-auto">

        <div class="d-inline-block ms-2" ngbDropdown>
          <button ngbDropdownToggle class="btn btn-sm btn-secondary">{{ texts.periodPrefix | localize }} {{ months }} {{ texts.monthsSuffix | localize }} <i class="fa-solid fa-chevron-down ms-2"></i></button>
          <div ngbDropdownMenu>
            <div class="clickable" (click)="months = 3; reload();" ngbDropdownItem>
              3 {{ texts.monthsSuffix | localize }}
            </div>
            <div class="clickable" (click)="months = 6; reload();" ngbDropdownItem>
              6 {{ texts.monthsSuffix | localize }}
            </div>
            <div class="clickable" (click)="months = 12; reload();" ngbDropdownItem>
              12 {{ texts.monthsSuffix | localize }}
            </div>
            <div class="clickable" (click)="months = 24; reload();" ngbDropdownItem>
              24 {{ texts.monthsSuffix | localize }}
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card card-xl">
          <div class="card-body">

            <div class="row mb-6 mt-4">
              <div class="col-12">
                <h3>{{ texts.impact | localize }}</h3>

                <p class="mb-5" style="max-width: 45rem;">
                  {{ texts.impactBody | localize }}
                </p>

                <div class="row">
                  <div class="col-4">
                    <h2 class="mb-1" *ngIf="reporting?.CostPerApplication != 'NaN'">
                      {{ reporting?.CostPerApplication | number : '0.0-0' }}€
                    </h2>
                    <h2 class="mb-1" *ngIf="reporting?.CostPerApplication == 'NaN'">
                      - €
                    </h2>
                    <span>Cost per Application</span>
                  </div>

                  <div class="col-4">
                    <h2 class="mb-1" *ngIf="reporting?.WorkloadPerApplication != 'NaN'">
                      {{ reporting?.WorkloadPerApplication  | number : '0.1-1' }} Min.
                    </h2>
                     <h2 class="mb-1" *ngIf="reporting?.WorkloadPerApplication == 'NaN'">
                      - Min.
                    </h2>
                    <span>Workload per Application</span>
                  </div>

                  <div class="col-4">
                    <h2 class="mb-1" *ngIf="reporting?.ReturnOnInvestment != 'NaN'">
                      {{ reporting?.ReturnOnInvestment | number : '0.0-0' }}%
                    </h2>
                     <h2 class="mb-1" *ngIf="reporting?.ReturnOnInvestment == 'NaN'">
                      - %
                    </h2>
                    <span>Return on Investment</span>
                  </div>
                </div>
               
              </div>
            </div>

            <hr class="mb-6">

            <div class="row mb-6">
              <div class="col-12">
                <h3>{{ texts.analysisRelease | localize }}</h3>

                <p class="mb-5" style="max-width: 45rem;">
                  {{ texts.analysisReleaseBody | localize }}
                </p>

                <div class="row mb-5">
                  <div class="col-4">
                    <h2 class="mb-1">
                      {{ reporting?.TotalPrepared | number }}
                    </h2>
                    <span>{{ texts.analyzedPositions | localize }}</span>
                  </div>

                  <div class="col-4">
                    <h2 class="mb-1">
                      {{ reporting?.TotalOrdered  | number }}
                    </h2>
                    <span>{{ texts.approvedPositions | localize }}</span>
                  </div>

                  <div class="col-4">
                    <h2 class="mb-1">
                      {{ reporting?.RateOrdered | number : '0.1-1' }}%
                    </h2>
                    <span>{{ texts.approvalRate | localize }}</span>
                  </div>
                </div>

                <div class="chart">
                  <canvas id="countByWeekChart" style="height: 40vh;" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>

            <hr class="mb-6">

           

            <div class="row mb-6">
              <div class="col-12">
                <h3>{{ texts.visitors | localize }}</h3>
                <p class="mb-5" style="max-width: 45rem;">
                  {{ texts.visitorsBody | localize }}
                </p>
                <div class="row mb-5">
                  <div class="col-4">
                    <h2 class="mb-1">
                      {{ reporting?.VisitedTotal | number }}
                    </h2>
                    <span>{{ texts.visitors | localize }}</span>
                  </div>
                </div>
                <div class="chart">
                  <canvas id="visitsPerWeekChart" style="height: 40vh;" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>

            <hr class="mb-6">

            <div class="row mb-6">
              <div class="col-12">
                <h3>{{ texts.applications | localize }}</h3>
                <p class="mb-5" style="max-width: 45rem;">
                  {{ texts.applicationsBody | localize }}
                </p>
                <div class="row mb-5">
                  <div class="col-4">
                    <h2 class="mb-1">
                      {{ reporting?.ListingsTotal | number }}
                    </h2>
                    <span>{{ texts.applications | localize }}</span>
                  </div>
                  <div class="col-4">
                    <h2 class="mb-1">
                      {{ reporting?.ListingsConversion | number : '0.1-1' }}%
                    </h2>
                    <span>{{ texts.conversionPerVisitor | localize }}</span>
                  </div>
                </div>
                <div class="chart">
                  <canvas id="listingsPerWeekChart" style="height: 40vh;" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
